module.exports = __webpack_public_path__ + "imgesssyaa/svg/Clock.abd1ed1b.svg";